<template>
	<div>
		<PageHeaderLayout>
			<div class="main-page-content">
				<el-row>
					<div class="flex-bw">
						<el-form :inline="true" :model="searchCondition">
							<el-form-item label="">
								<el-input
									v-model="searchCondition.name"
									placeholder="请输入关键词"
									clearable
									@keyup.enter.native="searchButton"
								></el-input>
							</el-form-item>
							<ScreeCompany
								ref="ScreeCompany"
								:allowField="allowField"
								@ScreeCompany="ScreeCompany"
							/>
							<el-form-item label="报送时间">
								<el-date-picker
									:picker-options="pickerOptions"
									format="yyyy 年 MM 月"
									value-format="yyyyMM"
									v-model="searchCondition.month"
									type="monthrange"
									placeholder="选择月份段"
									clearable
									range-separator="至"
									start-placeholder="开始月份"
									end-placeholder="结束月份"
								></el-date-picker>
							</el-form-item>
							<el-form-item>
								<el-button @click="searchButton" style="color: #1890ff"
									>查询</el-button
								>
							</el-form-item>
						</el-form>
					</div>
				</el-row>
				<el-row class="export-box">
					<div class="flex-bw">
						<div class="btn-box"></div>
						<div>
							<el-select
								v-model="value"
								placeholder="请选择导出类型"
								@change="selectData"
								class="select-box"
								size="medium"
							>
								<el-option
									v-for="item in options"
									:key="item.value"
									:label="item.label"
									:value="item.value"
								></el-option>
							</el-select>
							<el-button
								:loading="downloadLoading"
								style="margin: 0 0 20px 20px"
								type="primary"
								size="medium"
								icon="el-icon-document"
								@click="handleDownload"
							>
								导出
							</el-button>
						</div>
					</div>
				</el-row>

				<ApeTable
					ref="apeTable"
					:data="companyList"
					:columns="columns"
					:loading="loadingStaus"
					:pagingData="pagingData"
					@switchPaging="switchPaging"
					highlight-current-row
				>
				</ApeTable>
			</div>
		</PageHeaderLayout>
	</div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import ApeTable from "@/components/ApeTable";
import { mapGetters, mapState } from "vuex";
import ScreeCompany from "@/components/ScreeCompany.vue";
import moment from "moment";

export default {
	components: {
		PageHeaderLayout,
		ApeTable,
		ScreeCompany,
	},
	data() {
		return {
			// 允许显示的字段
			allowField: ["settlementId"],
			exportColumns: [
				{
					title: "是否已取得登记证照",
					value: "is_registration",
				},
				{
					title: "名称（已取得登记证照）",
					value: "y_name",
				},
				{
					title:
						"统一社会信用代码（纳税人识别号）（已取得登记证照）",
					value: "y_tax_no",
				},
				{
					title: "姓名（未取得登记证照）",
					value: "fullname",
				},
				{
					title: "证件类型（未取得登记证照）",
					value: "id_card_type",
				},
				{
					title: "证件号码（未取得登记证照）",
					value: "id_card",
				},
				{
					title: "国家或地区（未取得登记证照）",
					value: "country",
				},
				{
					title: "收入来源的互联网平台名称",
					value: "internet_platform",
				},
				{
					title: "收入来源的店铺（用户）名称",
					value: "customer_name",
				},
				{
					title: "收入来源的店铺（用户）唯一标识码",
					value: "customer_id",
				},
				{
					title: "销售货物取得的收入总额（已取得登记证照）",
					value: "y_goods_income",
				},
				{
					title: "销售货物取得的收入退款金额（已取得登记证照）",
					value: "y_goods_refund_income",
				},
				{
					title: "销售货物取得的收入净额（已取得登记证照）",
					value: "y_goods_net_income",
				},
				{
					title: "销售无形资产取得的收入总额（已取得登记证照）",
					value: "y_intangible_income",
				},
				{
					title:
						"销售无形资产取得的收入退款金额（已取得登记证照）",
					value: "y_intangible_refund_income",
				},
				{
					title: "销售无形资产取得的收入净额（已取得登记证照）",
					value: "y_intangible_net_income",
				},
				{
					title: "销售服务取得的收入总额（已取得登记证照）",
					value: "y_service_income",
				},
				{
					title: "销售服务取得的收入退款金额（已取得登记证照）",
					value: "y_service_refund_income",
				},
				{
					title: "销售服务取得的收入净额（已取得登记证照）",
					value: "y_service_net_income",
				},
				{
					title: "收入总额（未取得登记证照）",
					value: "income",
				},
				{
					title: "退款金额（未取得登记证照）",
					value: "refund_income",
				},
				{
					title: "小计（未取得登记证照）",
					value: "subtotal",
				},
				{
					title: "销售货物收入（未取得登记证照）",
					value: "goods_income",
				},
				{
					title: "运输服务收入（未取得登记证照）",
					value: "transport_service_income",
				},
				{
					title: "劳务报酬（未取得登记证照）",
					value: "labor_income",
				},
				{
					title: "稿酬（未取得登记证照）",
					value: "manuscript_income",
				},
				{
					title: "特许权使用费（未取得登记证照）",
					value: "royalties_income",
				},
				{
					title: "从事其他网络交易活动取得的收入（净额）",
					value: "other_income",
				},
				{
					title: "支付给平台的佣金，服务费合计金额",
					value: "commission_income",
				},
				{
					title: "交易数量",
					value: "order_num",
				},
			],
			columns: [
				{
					title: "税源地名称",
					value: "channel_name",
				},
				{
					title: "是否已取得登记证照",
					value: "is_registration",
				},
				{
					title: "姓名（未取得登记证照）",
					value: "fullname",
				},
				{
					title: "证件类型（未取得登记证照）",
					value: "id_card_type",
				},
				{
					title: "证件号码（未取得登记证照）",
					value: "id_card",
				},
				{
					title: "国家或地区（未取得登记证照）",
					value: "country",
				},
				{
					title: "收入来源的互联网平台名称",
					value: "internet_platform",
				},
				{
					title: "收入来源的店铺(用户)名称",
					value: "customer_name",
				},
				{
					title: "收入来源的店铺(用户)唯一标识码",
					value: "customer_id",
				},
				{
					title: "收入总额（未取得登记证照）",
					value: "income",
				},
				{
					title: "退款金额（未取得登记证照）",
					value: "refund_income",
				},
				{
					title: "收入净额小计（未取得登记证照）",
					value: "subtotal",
				},
				{
					title: "销售货物收入净额（未取得登记证照）",
					value: "goods_income",
				},
				{
					title: "运输服务收入净额（未取得登记证照）",
					value: "transport_service_income",
				},
				{
					title: "劳务报酬收入净额（未取得登记证照）",
					value: "labor_income",
				},
				{
					title: "稿酬收入净额（未取得登记证照）",
					value: "manuscript_income",
				},
				{
					title: "特许权使用费收入净额（未取得登记证照）",
					value: "royalties_income",
				},
				{
					title: "从事其他网络交易活动取得的收入（净额）",
					value: "other_income",
				},
				{
					title: "支付给平台的佣金服务费合计金额",
					value: "commission_income",
				},
				{
					title: "交易数量",
					value: "order_num",
				},
			],
			// 搜索条件
			searchCondition: {
				name: "",
				channel_account: "",
				month: "",
			},
			loadingStaus: true,
			// 表格列表数据
			companyList: [],
			// 分页信息
			pagingData: {
				is_show: true,
				layout: "total, sizes, prev, pager, next, jumper",
				total: 0,
			},
			// 分页的offset,序号列使用
			offset: 0,
			options: [
				{
					value: "xlsx",
					label: "xlsx",
				},
				{
					value: "csv",
					label: "csv",
				},
				{
					value: "txt",
					label: "txt",
				},
			],
			value: "xlsx",
			bookType: "xlsx", //导出表格类型
			downloadLoading: false,
		};
	},

	computed: {
		...mapGetters(["userPermissions", "buttonType"]),
		...mapState({
			userInfo: (state) => state.userInfo,
		}),
		pickerOptions() {
			const year = new Date().getFullYear();
			return {
				disabledDate: this.disabledDate,
				shortcuts: [
					{
						text: "第一季度",
						onClick: (picker) => {
							// 第一季度：1月1日 - 3月31日
							const start = new Date(year, 0, 1); // 1月1日
							const end = new Date(year, 2, 31); // 3月31日
							picker.$emit("pick", [start, end]);
						},
					},
					{
						text: "第二季度",
						onClick: (picker) => {
							// 第二季度：4月1日 - 6月30日
							const start = new Date(year, 3, 1); // 4月1日
							const end = new Date(year, 5, 30); // 6月30日
							picker.$emit("pick", [start, end]);
						},
					},
					{
						text: "第三季度",
						onClick: (picker) => {
							// 第三季度：7月1日 - 9月30日
							const start = new Date(year, 6, 1); // 7月1日
							const end = new Date(year, 8, 30); // 9月30日
							picker.$emit("pick", [start, end]);
						},
					},
				],
			};
		},
	},
	watch: {
		"$route.matched": function (n, o) {
			console.log(o);
			if (n.length === 2) {
				this.init();
			}
		},
	},
	methods: {
		ScreeCompany(option, key) {
			console.log(option, key);
			if (key === "settlement") {
				this.searchCondition.channel_account = option;
			}
		},
		disabledDate(time) {
			return time.getTime() > Date.now();
		},

		//导出
		async handleDownload() {
			this.downloadLoading = true;
			let list = await this.init("export");
			if (!list || list.length === 0) {
				this.$message.warning("暂无数据可导出");
				this.downloadLoading = false;
				return;
			}
			import("@/excel/Export2Excel").then((excel) => {
				let sHeader = this.exportColumns.map((item) => item.title);
				const data = this.formatJson(list);
				const time = new Date().getTime() + Math.random() * 1000;
				let filename = `收入信息报送表${time}`;
				excel.export_json_to_excel({
					header: sHeader, //Header Required
					data, //Specific data Required
					filename: filename, //Optional
					autoWidth: true, //Optional
					bookType: this.bookType, //Optional
				});
				this.downloadLoading = false;
			});
		},
		//转换导出数据
		formatJson(jsonData) {
			return jsonData.map((v) => {
				let tempArr = [];
				this.exportColumns.map((item) => {
					tempArr.push(v[item.value] || "");
				});
				return tempArr;
			});
		},
		//选择导出类型
		selectData(e) {
			this.bookType = e;
		},

		// 搜索
		searchButton() {
			this.init("search");
		},

		// 切换页码操作
		async switchPaging() {
			this.init();
		},

		// 初始化列表
		async init(type) {
			let pagingInfo = this.$refs["apeTable"]?.getPagingInfo(type) || {
				current_page: 1,
				page_size: 10,
			};
			if (type == "export") {
				pagingInfo.page_size = 50000;
				console.log(pagingInfo, "页面对象");
			} else {
				this.loadingStaus = true;
			}
			if (type == "search") {
				pagingInfo.current_page = 1;
			}
			let searchCondition = this.handleSearchCondition();
			Object.assign(searchCondition, pagingInfo);
			let { data, pages } = await this.$api.get_qxy_tax_income_info_list(
				searchCondition
			);

			if (type == "export") {
				return data || [];
			} else {
				this.companyList = [];
				this.$nextTick(() => {
					this.companyList = data || [];
				});
				this.pagingData.total = pages?.total || 0;
				console.log(this.pagingData.total, "总数");
				this.offset = pages?.offset || 0;
				this.loadingStaus = false;
			}
		},
		// 处理搜索条件
		handleSearchCondition() {
			let searchCondition = {}
			if(this.searchCondition.month){
				searchCondition.start_time=this.searchCondition.month[0]
				searchCondition.end_time=this.searchCondition.month[1]
			}
			if(this.searchCondition.channel_account){
				searchCondition.channel_account=this.searchCondition.channel_account
			}
			if(this.searchCondition.name){
				searchCondition.name=this.searchCondition.name
			}
			return searchCondition;
		},

		keyupSubmit() {
			document.onkeydown = (e) => {
				console.log(e);
				let _key = window.event.keyCode;
				if (_key === 13) {
					this.searchButton();
				}
			};
		},
	},
	created() {
		this.keyupSubmit();
	},
	mounted() {
		// 默认选择上个月的第一天和最后一天
		const lastMonth = moment().subtract(1, "M");
		const startDate = lastMonth.startOf("month").format("YYYYMM");
		const endDate = lastMonth.endOf("month").format("YYYYMM");
		this.searchCondition.month = [startDate, endDate];
		this.init();
	},
};
</script>

<style lang="scss" scoped>
::v-deep .el-row {
	margin-bottom: 0;
}
.name {
	cursor: pointer;
	color: #409eff;
}
.flex-bw {
	display: flex;
	justify-content: space-between;
}
.btn-box {
	width: 360px;
	flex: none;
}
.table-right {
	float: right;
}
</style>